<div class="container section-gap">
  <div class="row">
    <div class="col-12" #panel>
      <kla-title [lineConfig]="lineConfig" [config]="titleConfig" [showFooter]="false"></kla-title>
    </div>
    <div class="col-12" #panel>
      <kla-multi-image-chart *ngIf="config && config.visible" [config]="config"></kla-multi-image-chart>
      <div class="footer-paragraph" *ngIf="titleConfig.footer">
        <app-dynamic-content
          [contentId]="'multi-image-footer'"
          [htmlContent]="titleConfig.footer">
        </app-dynamic-content>
      </div>
    </div>
  </div>
</div>
